<template>
  <div class="tinymce-container">
    <editor
      v-model="myValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
			:key="UUID"
    />
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default' // 解决图标缺失问题
import 'tinymce/plugins/image' // 图片插件
import 'tinymce/plugins/media' // 媒体插件
import 'tinymce/plugins/table' // 表格插件
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/wordcount' // 字数统计
import 'tinymce/plugins/paste' // 粘贴插件
import 'tinymce/plugins/contextmenu' // 粘贴插件
import 'tinymce/plugins/code' // 粘贴插件
import 'tinymce/plugins/link' // 粘贴插件
import 'tinymce/plugins/hr' // 粘贴插件
import 'tinymce/plugins/fullscreen' // 粘贴插件
import 'tinymce/plugins/anchor' // 粘贴插件
import customAnchor from '@/utils/customAnchor'; // 引入自定义插件
import * as util from "@/utils/util.js"

export default {
  name: 'TinymceEditor',
  components: { Editor },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'link anchor hr lists image media table wordcount paste contextmenu code fullscreen'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo | fontselect fontsizeselect | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | lineheight | bullist numlist outdent indent | link customAnchor hr lists image media table | code removeformat fullscreen'
    },
		anchorList:{
			type: Array,
			default: []
		},
		type: {
		  type: String,
		  default: ''
		},
		
  },
  data() {
    return {
      myValue: '',
      init: {
        language_url: '/tinymce/langs/zh_CN.js', // 需自行下载中文包放入public目录
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide', // 需自行下载skin放入public目录
        content_css: '/tinymce/skins/content/default/content.css',
				content_style: 'body { font-family:Microsoft YaHei; font-size:16px; line-height: 1; }',
        height: 600,
        plugins: this.plugins,
        toolbar: this.toolbar,
				font_formats: '微软雅黑=Microsoft YaHei,Helvetica,Arial,sans-serif;' +
											'宋体=SimSun,serif;' +
											'仿宋=仿宋;' +
											'黑体=SimHei,sans-serif;' +
											'楷体=KaiTi;' +
											'隶书=隶书;' +
											'Arial=arial,helvetica,sans-serif;' +
											'Courier New=courier new,courier,monospace;' +
											'Georgia=georgia,palatino;' +
											'Times New Roman=times new roman,times,serif;' +
											'Verdana=verdana,geneva;',
				fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px 48px 64px',
				lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 1.75 2 2.5 3 4 5',
        branding: false,
        menubar: false,
				paste_data_images: true, // 允许粘贴图像，图片粘贴自动上传需要
        // 核心配置：处理图片上传
        images_upload_handler: (blobInfo, success, failure) => {
          const formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());
          
					let baseUrl='';
					
					if(process.env.NODE_ENV=='development'){
						baseUrl='/api'
					}
          // 替换为你的后端上传接口
          fetch(baseUrl + '/handler/upload.ashx', {
            method: 'POST',
            body: formData
          })
          .then(res => res.json())
          .then(res => {//console.log(res);
            if (res.errorCode === '0') {
              success(res.url); // 返回图片URL
            } else {
              failure('上传失败');
            }
          })
          .catch(err => {
            failure('网络错误');
          });
        },
				setup: (editor) => {
					// 在 setup 中注册插件逻辑，或者确保 customAnchorPlugin 已经执行了 PluginManager.add
					// 如果 customAnchor 是一个函数，可以这样调用：
					customAnchor(editor, this.anchorList);
				},
				content_style: `
				    /* 让自定义锚点在编辑器中显示为蓝色小方块 */
				    .custom-anchor {
				          display: inline-block;
				          width: 12px;
				          height: 12px;
				          background-color: #3b82f6;
				          border-radius: 50%;
				          margin: 0 4px;
				          vertical-align: middle;
				          cursor: pointer;
				          position: relative;
				        }
				        
				        /* 鼠标悬停时显示提示 */
				        .custom-anchor:hover::after {
				          content: '锚点：' attr(title);
				          position: absolute;
				          bottom: 100%;
				          left: 40px;
				          transform: translateX(-50%);
				          background: #333;
				          color: #fff;
				          padding: 2px 6px;
				          font-size: 12px;
				          border-radius: 4px;
				          white-space: nowrap;
				        }
				  `
      },
			UUID: '',
			
    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    },
		anchorList: {
			handler(newVal, oldVal) {
				//console.log('anchorList', newVal);
				
			  this.UUID=util.CreateUUID();
			},
			deep: true,
		}
  },
  methods: {
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    }
  },
	created(){
		this.UUID=util.CreateUUID();
		this.myValue=this.value;
	},
  mounted() {
		this.$nextTick(()=>{
			tinymce.init({})
		});
    
  }
}
</script>

<style scoped>
.tinymce-container {
  line-height: normal;
}
</style>
